<!-- 
Panel for displaying SAP configuration.

This cannot be edited from the UI.
-->
<template>
  <div>
    <h3 class="title mb-0 ml-4 mt-4">
      SAP codes <span class="body-1 pl-2">{{ subtitle }}</span>
      <our-user-guide-button topic="levy-collection-setup" section="sap-codes" in-title/>
    </h3>
    <our-data-container>
      <our-data-field label="Company code" label-width="3">{{ configuration.companyCode }}</our-data-field>
      <our-data-field label="General ledger account ID" label-width="3">{{ configuration.generalLedgerAccountId }}</our-data-field>
      <our-data-field label="Cost centre ID" label-width="3">{{ configuration.costCentreId }}</our-data-field>
    </our-data-container>
  </div>
</template>

<script>
import lookupMixins from "@/mixins/lookup.mixins";
import filterMixins from "@/mixins/filter.mixins";
import * as action from "@/store/system/action-types";

export default {
  mixins: [lookupMixins, filterMixins],
  props: {
    levyCollectionType: {
      validator: prop => typeof prop === "string" || prop === null,
      required: true
    }
  },
  computed: {
    state() {
      return this.$store.state.system.sapConfiguration;
    },
    loaded() {
      return this.state.loaded;
    },
    configuration() {
      return this.state.data;
    },
    subtitle() {
      return this.levyCollectionType
        ? `(current settings for ${
            this.lookups.levyCollectionTypeDescriptions[this.levyCollectionType]
          } levy collections - contact IT if any of these need to be changed)`
        : "";
    }
  },
  watch: {
    levyCollectionType() {
      this.refresh();
    },
    loaded() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      if (this.levyCollectionType) {
        const needsReloaded =
          (!this.state.loaded && !this.state.loading) || this.state.levyCollectionType != this.levyCollectionType;
        if (needsReloaded) {
          this.$store.dispatch(action.SAP_CONFIGURATION_GET, this.levyCollectionType);
        }
      }
    }
  }
};
</script>
